export const NIVEL_COPAS = 100;
export const COPA_PAIS = 100;
export const SUPERCOPA_PAIS = 101;
export const COPA_LIGA = 102;
